import React, { Component } from 'react';
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import Settings from '../../../../_components/common/SettingsHeader';
import DetailsPanel from '../../../../_components/common/TableNew/details'
import TableNew from '../../../../_components/common/TableNew'
import { sellerImageService } from '../../../../_services';
import { tables } from './tableColumns';
import { sellerActions, sellerAdminActions, creditListActions, editSellerActions, AddSellerAdminAction, organisationListActions, sellCreditAction, revokeCreditAction, sellerImageAction, deleteSellerAction, RemoveSellerAdminAction, MakePrimaryAdminAction, removeSellerImageAction } from '../../../../_actions';
import { connect } from 'react-redux';
import ModalNew from '../../../../_components/common/ModalNew';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import { formData } from '../formData';
import { addSellerAdmin, sellCredits, revokeCredits } from '../formData';
import SweetAlert from 'sweetalert2-react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import swal from 'sweetalert2/dist/sweetalert2.min.js';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';

import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';

import Page404 from '../../../404page';

class Details extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            sellCredits: false,
            revokeCredits: false,
            sellerAdmin: false,
            selectedImage: null,
            instrumentId: null,
            instrumentDetails: null,
            adminDetails: null,
            primaryAdminModal: false,
            primaryAdminDetails: null,
            sortType: false,
            creditsData: '',
            adminsData: '',
            organizationsData: '',
            showSwal: false,
            subModal: false,
            responseModal: false,
            editSellerData: '',
            editSellerState: false,
            deleteSellerState: false,
            addSellerAdminState: false,
            sellerId: this.props.location.state ? this.props.location.state.columnData.id : 0,
            availableCredits: 0
            // imageMessage:''
            // selectedFile : null
        }
    }

    componentDidMount() {
    
        if(this.props.location.state) {
            const { id } = this.props.location.state.columnData;
            const { dispatch } = this.props;
            dispatch(sellerAdminActions.getSellerAdmins(id));
            dispatch(creditListActions.getCreditList(id));
            dispatch(organisationListActions.getOrganisations(id));
        }
    }

    toggleModal(showModal) {
   
        this.setState({
            modal: showModal
        });
    }



    toggleSellerPrimaryAdmin(showModal, adminDetails) {
        this.setState({
            primaryAdminModal: false,
            deleteSellerState: false,
            sellerAdmin: false,
            primaryAdminModal: showModal,
            primaryAdminDetails: adminDetails
        })
    }

    toggleSellCreditsModal(showModal, id) {
        let availableCredits = 0
        if (showModal === true) {

            for (let i = 0; i < this.props.credits.length; i++) {
                const element = this.props.credits[i];
             
                if (element.instrument__id === id) {
                    availableCredits = element.unsold_credits
                }
            }
        }
        this.setState({
            primaryAdminModal: false,
            deleteSellerState: false,
            sellerAdmin: false,
            sellCredits: showModal,
            instrumentId: id,
            availableCredits
        });
    }

    toggleRevokeCreditsModal(showModal, instrument) {
     
        let availableCredits
        if (showModal === true) {

            for (let i = 0; i < this.props.credits.length; i++) {
                const element = this.props.credits[i];
                if (instrument.instrument__id === element.instrument__id) {
                    availableCredits = element.unsold_credits
                }
            }
        }

        this.setState({
            primaryAdminModal: false,
            sellerAdmin: false,
            deleteSellerState: false,
            revokeCredits: showModal,
            instrumentDetails: instrument,
            instrumentId: instrument.instrument__id,
            availableCredits
        });
    }

    toggleRemoveSellerAdmin(showModal, adminDetails) {
        this.setState({
            primaryAdminModal: false,
            deleteSellerState: false,
            sellerAdmin: showModal,
            adminDetails: adminDetails
        })
    }


    onImageUpload = (ev) => {

        if (ev.target.files && ev.target.files[0].name) {
            this.setState({ showSwal: true })
            this.setState({ selectedFile: ev.target.files[0] })
            const fd = new FormData()
            fd.append('seller_image', ev.target.files[0]);
            this.props.dispatch(sellerImageAction.setSellerImage(fd, this.props.location.state.columnData.id))

        }
    }

    onImageDelete = () => {
        // e.stopPropagation();
        swal({
            text: `Are you sure you want remove seller image`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                this.setState({ selectedImage: '' })
                const fd = new FormData();
                fd.append('seller', this.props.location.state.columnData.id);
                this.props.dispatch(removeSellerImageAction.removeSellerImage(fd))
            }
        })

     
    }


    compareBy(key) {
        if (this.state.sortType == true) {
            return function (a, b) {
                if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
                return 0;
            };
        }

        if (this.state.sortType == false) {
            return function (a, b) {
                if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
                return 0;
            };
        }
    }


    sortBy(columnKey, type, tableName) {
        this.setState({ sortType: type })
        if (tableName === 'creditsTable') {
            const arrayCopy = this.state.creditsData === '' ? this.props.credits : this.state.creditsData;
            arrayCopy.sort(this.compareBy(columnKey));
            this.setState({ creditsData: arrayCopy })
        }

        if (tableName === 'adminTable') {
            const adminArrayCopy = this.state.adminsData === '' ? this.props.admins : this.state.adminsData;
            adminArrayCopy.sort(this.compareBy(columnKey));
            this.setState({ adminsData: adminArrayCopy })
        }

        if (tableName === 'organizationTable') {
            const organizationArrayCopy = this.state.organizationsData === '' ? this.props.organisations : this.state.organizationsData;
            organizationArrayCopy.sort(this.compareBy(columnKey));
            this.setState({ organizationsData: organizationArrayCopy })
        }

    }

    editSellerAction(data) {
  
        this.props.dispatch(editSellerActions.addData(data.sellerData, data.id))
    }

    sellerSellCreditsAction(data) {
   

        this.props.dispatch(sellCreditAction.addData(data.sellerData))

        sellCredits.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    sellerRevokeCreditsAction(data) {
  
        data.sellerData.instrument_id = this.state.instrumentId
        this.props.dispatch(revokeCreditAction.addData(data.sellerData))

        revokeCredits.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    addSellerAdminAction(data) {
        const formData = data.sellerData;

        const fd = {
            'email': data.sellerData.email.toLowerCase(),
            'full_name': data.sellerData.full_name,
            'seller_id': data.sellerData.seller_id,
            'short_name': data.sellerData.short_name
        }
    

        this.props.dispatch(AddSellerAdminAction.addData(fd))
  
        this.props.dispatch(sellerAdminActions.getSellerAdmins(this.props.location.state.columnData.id))

    }

    toggleEntireSellCreditsModal(showModal) {
        this.setState({
            sellCredits: showModal
        })
    }

    toggleEntireRevokeCreditsModal(showModal) {
        this.setState({
            revokeCredits: showModal
        })
    }

    toggleEntireAddAdminModal(showModal) {
        this.setState({
            addSellerAdminState: showModal
        })
    }

    toggleEditSellerModal(showModal) {
 
        this.setState({
            primaryAdminModal: false,
            sellerAdmin: false,
            deleteSellerState: false,
            editSellerState: showModal
        })
    }

    toggleEntireEditSellerModal(showModal) {
        this.setState({
            editSellerState: showModal
        })
    }

    toggleDeleteSellerModal(showModal) {
    
        this.setState({
            primaryAdminModal: false,
            sellerAdmin: false,
            deleteSellerState: showModal
        })
    }

    toggleAddSellerAdminModal(showModal) {
        this.setState({
            primaryAdminModal: false,
            sellerAdmin: false,
            deleteSellerState: false,
            addSellerAdminState: showModal
        })

        addSellerAdmin.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    getSellerData() {
        for (let i in this.props.sellers) {
            if (this.props.sellers[i].id === this.state.sellerId) {
                return this.props.sellers[i]
            }
        }
    }

    render() {
        if(this.props.location.state) {
            const { columnData } = this.props.location.state;
       
            const { loading, admins, creditsLoading, credits, organisations, editSellerResponse, sellers,sellerError, sellerLoading, removeSellerImageLoading, removeSellerImageResponse } = this.props;
            const creditsData = this.state.creditsData === '' ? credits : this.state.creditsData;
            const adminsData = this.state.adminsData === '' ? admins : this.state.adminsData
            const organizationsData = this.state.organizationsData === '' ? organisations : this.state.organizationsData;
            const editSellerData = sellers === '' ? columnData : this.getSellerData();
            let image = (this.state.selectedImage === null ? columnData.seller_image : this.state.selectedImage);
            formData.map(
                (data, i) => {
                    data.value = editSellerData[data.key] === 0 ? '' : editSellerData[data.key];
                    data.valid = true;
                }
            )

            addSellerAdmin.map(
                (data, i) => {
                    if (data.key === 'seller_id') {
                        data.value = columnData.id;
                    }
                }
            )

            sellCredits.map(
                (data, i) => {
                    if (data.key === 'seller_id') {
                        data.value = columnData.id;
                    }
                }
            )
            revokeCredits.map(
                (data, i) => {
                    if (data.key === 'seller_id') {
                        data.value = columnData.id;
                    }
                }
            )

            let buttonDataProp = [
                {
                    id: 1,
                    heading: "EDIT SELLER",
                    // state: this.state.editRelationGroupState,
                    toggler: this.toggleEditSellerModal.bind(this),
                    togglerModal: this.state.editSellerState
                },
                {
                    id: 2,
                    heading: "DELETE SELLER",
                    toggler: this.toggleDeleteSellerModal.bind(this),
                    togglerModal: this.state.deleteSellerState
                }
            ]

            let adminButtonData = [
                {
                    id: 1,
                    heading: "ADD A NEW SELLER ADMIN",
                    toggler: this.toggleAddSellerAdminModal.bind(this),
                    togglerModal: this.state.addSellerAdminState
                }
            ]

            creditsData !== '' &&
                creditsData.map(val => {
                    if (!val.sold__credits_in_use || val.sold__credits_in_use === undefined) {
                        val["sold__credits_in_use"] = `${val.sold_credits}(${val.credit_in_use})`
                    }
                })

            organizationsData !== '' &&
                organizationsData.map(val => {
               
                    val['total_sold'] = val.sold_credits + val.unsold_credits
                })

               

            return (
                <div>
                    <NavBar />
                    <div className="container my-5" >
                        <div>
                            <CommonBreadCrumb
                                data={[
                                    {
                                        link: '/admin/app/dashboard',
                                        name: 'ADMIN'
                                    }, {
                                        link: '/admin/app/sellers',
                                        name: 'SELLERS'
                                    }, {
                                        link: '',
                                        name: 'SELLERS DETAILS'
                                    }
                                ]}
                            />
                        </div>

                        <div className="bg-green rounded-top">
                            <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {editSellerData.seller_name} </p >                        

                            {/* <i className="fas fa-spinner fa-spin text-white"></i> */}
                        </div>

                        <Settings
                            buttonData={buttonDataProp}
                            filter={false}
                            // secondColumn={false}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />

                        {
                            this.state.editSellerState &&
                            <ModalNew
                                modalName="editSeller"
                                id={columnData.id}
                                heading="Edit Seller Details"
                                showModal={this.state.editSellerState}
                                formData={formData.map(data => {
                                    if(data.key === 'seller_code') {
                                        return {
                                            ...data,
                                            type: 'plaintext'
                                        }
                                    }else {
                                        return data
                                    }
                                })}
                                action={this.editSellerAction.bind(this)}
                                toggleEntireModal={this.toggleEntireEditSellerModal.bind(this)}
                                selectKey={['id', 'id']}
                                selects={['seller_name', 'country_name']}
                            />
                        }

                        {
                            this.state.deleteSellerState &&
                            <SweetAlert
                                show={this.state.deleteSellerState}
                                title=''
                                text={`Are you sure you want to delete ${editSellerData.seller_name}?`}
                                type="warning"
                                showCancelButton={true}
                                confirmButtonColor="#3085d6"
                                cancelButtonColor='#d33'
                                confirmButtonText='Yes, delete it!'
                                onConfirm={() => {
                                    const data = {
                                        'seller_id': columnData.id
                                    }
                                    this.props.dispatch(deleteSellerAction.deleteSeller(data, (del_data) => {
                                        this.props.history.replace('/admin/app/sellers');
                                        window.location.reload();
                                    }))
                                    this.setState({ deleteSellerState: false })
                                }
                                }
                                onCancel={() => {
                                    this.setState({ deleteSellerState: false })
                                }}
                            />
                        }

                        <DetailsPanel
                            heading={"Code: " + editSellerData.seller_code}
                            selectedImage={image}
                            onImageSelected={(ev) => { this.onImageUpload(ev) }}
                            data={[editSellerData.city, <br />, editSellerData.address, <br />, editSellerData.state, <br />, editSellerData.country__country_name, <br />, editSellerData.pincode === 0 ? '' : editSellerData.pincode]}
                            onClickImg={this.onImageDelete}
                        />

                        <div className="bg-green rounded-top mt-5">
                            <p className="text-center text-uppercase py-2 text-white mb-0 position-relative quattrocentosans regular" > Credits </p>
                            {
                                this.props.creditsLoading &&
                                <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                            }
                        </div>

                        <TableNew
                            data={creditsData}
                            columns={tables.credits}
                            showSlNo="false"
                            sellCreditsModal={this.toggleSellCreditsModal.bind(this)}
                            sellCreditsShowModal={this.state.sellCredits}
                            revokeCreditsModal={this.toggleRevokeCreditsModal.bind(this)}
                            revokeCreditsShowModal={this.state.revokeCredits}
                            sortBy={(key) => this.sortBy(key, !this.state.sortType, 'creditsTable')}
                            sortType={this.state.sortType}
                        />

                        {
                            this.state.sellCredits &&
                            <ModalNew
                                modalName="addCredits"
                                heading="ADD CREDITS"
                                showModal={this.state.sellCredits}
                                formData={sellCredits}
                                action={this.sellerSellCreditsAction.bind(this)}
                                instrumentId={this.state.instrumentId}
                                sellCredits={this.state.sellCredits}
                                id={columnData.id}
                                toggleEntireModal={this.toggleEntireSellCreditsModal.bind(this)}
                            />
                        }

                        {
                            this.state.revokeCredits &&
                            <ModalNew
                                modalName="revokeCredits"
                                heading="REVOKE CREDITS"
                                showModal={this.state.revokeCredits}
                                formData={revokeCredits}
                                action={this.sellerRevokeCreditsAction.bind(this)}
                                instrumentId={this.state.instrumentId}
                                sellCredits={this.state.revokeCredits}
                                id={columnData.id}
                                toggleEntireModal={this.toggleEntireRevokeCreditsModal.bind(this)}
                            />
                        }

                        <div className="bg-green rounded-top mt-5">
                            <p className="text-center text-uppercase py-2 text-white mb-0 position-relative quattrocentosans regular"> Organisations </p>
                            {
                                this.props.orgLoading &&
                                <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                            }
                        </div>

                        <TableNew
                            columns={tables.organisations}
                            data={organizationsData}
                            showSlNo="false"
                            sortBy={(key) => this.sortBy(key, !this.state.sortType, 'organizationTable')}

                            sortType={this.state.sortType}
                        />

                        <div className="bg-green rounded-top mt-5">
                            <p className="text-center text-uppercase py-2 text-white mb-0 position-relative"> SELLER ADMINS </p>
                            {
                                this.props.loading &&
                                <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                            }
                        </div>

                        <Settings
                            buttonData={adminButtonData}
                            filter={false}
                            // secondColumn={false}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />

                        <TableNew
                            data={adminsData}
                            columns={tables.admins}
                            showSlNo="false"
                            sellerAdminModal={this.toggleRemoveSellerAdmin.bind(this)}
                            sellerAdminShowModal={this.state.sellerAdmin}
                            modalOne={this.toggleSellerPrimaryAdmin.bind(this)}
                            primaryAdminShowModal={this.state.primaryAdminModal}
                            sortBy={(key) => this.sortBy(key, !this.state.sortType, 'adminTable')}
                            sortType={this.state.sortType}
                        />

                        {
                            this.state.addSellerAdminState &&
                            <ModalNew
                                modalName="addSellerAdmin"
                                heading="ADD SELLER ADMIN"
                                showModal={this.state.addSellerAdminState}
                                formData={addSellerAdmin}
                                action={this.addSellerAdminAction.bind(this)}
                                toggleEntireModal={this.toggleEntireAddAdminModal.bind(this)}

                            />
                        }

                        {
                            this.state.sellerAdmin &&
                            <SweetAlert
                                show={this.state.sellerAdmin}
                                title=''
                                text="Are you sure want to remove Admin?"
                                type='warning'
                                showCancelButton={true}
                                confirmButtonColor='#3085d6'
                                cancelButtonColor='#d33'
                                confirmButtonText='Yes, delete it!'
                                onConfirm={() => {
                                    const data = {
                                        'email': this.state.adminDetails
                                    }
                                    this.props.dispatch(RemoveSellerAdminAction.removeSellerAdmin(data))

                                    this.setState({ sellerAdmin: false })
                                    this.setState({ subModal: true })
                                }
                                }
                                onCancel={() => {
                                    this.setState({ sellerAdmin: false })
                                }}
                            />
                        }

                        {
                            this.state.primaryAdminModal &&
                            <SweetAlert
                                show={this.state.primaryAdminModal}
                                title=''
                                text="Are you sure want to make primary admin?"
                                type='warning'
                                showCancelButton={true}
                                confirmButtonColor='#3085d6'
                                cancelButtonColor='#d33'
                                confirmButtonText='OK'
                                onConfirm={() => {
                                    const data = {
                                        'email': this.state.primaryAdminDetails,
                                        'seller_id': columnData.id
                                    }
                                    this.props.dispatch(MakePrimaryAdminAction.makePrimaryAdmin(data))
                                    this.setState({ primaryAdminModal: false })
                                    this.setState({ subModal: true })
                                }
                                }
                                onCancel={() => {
                                    this.setState({ primaryAdminModal: false })
                                }}
                            />
                        }

                        {
                            this.state.subModal &&
                            <SweetAlert
                                show={this.state.subModal}
                                type='success'
                                title=''
                                text={'Successful'}
                                showCancelButton={false}
                                confirmButtonColor='#3085d6'
                                confirmButtonText='OK'
                                onConfirm={() => {
                                    this.setState({ subModal: false })
                                    this.props.dispatch(sellerAdminActions.getSellerAdmins(columnData.id));
                                }}
                            />
                        }

                        {
                            this.props.sellerImageResponseCode === 200 &&
                            <SweetAlert
                                show={this.state.showSwal}
                                title=''
                                text={"Image Uploaded Successfully"}
                                type='success'
                                showCancelButton={false}
                                confirmButtonColor='#3085d6'
                                confirmButtonText='OK'
                                onConfirm={() => {
                                    this.setState({ selectedImage: this.props.sellerImageResponse.data.image_path })
                                    this.setState({ showSwal: false })
                                }
                                }
                            />
                        }

                    </div>
                    <Footer />
                </div>
            );
        }else {
            return (
                <div>
                    <NavBar />
                    <Page404 />
                    <Footer />
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { error, orgError, creditsError } = state;
    const admins = (!loading && !error) ? state.sellerAdmins.admins : '';

    const { loading } = state.sellerAdmins;
    const { orgLoading } = state.organisations;
    const { creditsLoading } = state.credits;
    const credits = (!creditsLoading && !creditsError) ? state.credits.credits : '';
    const organisations = (!orgLoading && !orgError) ? state.organisations.organisations : '';

    const { sellerImageLoading } = state.sellerImage;
    const sellerImageResponse = (!sellerImageLoading) ? state.sellerImage.data : '';
    const sellerImageResponseCode = (!sellerImageLoading) ? state.sellerImage.data.status : '';

    const { editLoading } = state.updateSeller;
    const editSellerResponse = (!editLoading) ? state.updateSeller.response.data : '';

    const sellerLoading = state.seller.loading;
    const sellerError = state.seller.error;
    const sellers = (!sellerLoading && !sellerError) ? state.seller.seller.data.seller_list : '';

    const removeSellerImageLoading = state.removeSellerImage;
    const removeSellerImageResponse = (!removeSellerImageLoading) ? state.removeSellerImage.data.status : '';
    return {
        admins,
        loading,

        creditsLoading,
        credits,
        orgLoading,
        organisations,

        editSellerResponse,

        sellerImageLoading,
        sellerImageResponse,
        sellerImageResponseCode,

        sellers,
        sellerError,
        sellerLoading,

        removeSellerImageLoading,
        removeSellerImageResponse,
    };
}

export default connect(mapStateToProps)(Details);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Sellers/Details/index.jsx